

export const filterItemsStatePerPage = 10;
export const filterItemsYearPerPage = 4;
const acData = sessionStorage.getItem('acData');
const parsedACData = JSON.parse(acData)
export const urls = ['/school-reports','/school-reports-1004',
                     '/school-reports-1005', '/school-reports-1003', '/school-reports-1006','/school-reports-1007','/school-reports-1008','/school-reports-1009','/school-reports-1010','/school-reports-1011','/school-reports-1013','/school-reports-1014',
                     '/teacher-reports-2008', '/teacher-reports-2007',
                     '/teacher-reports-2001','/teacher-reports-2002','/teacher-reports-2006','/teacher-reports-2004','/teacher-reports-2005','/teacher-reports-2003','/teacher-reports-2009','/teacher-reports-2010', '/teacher-reports-2011',
                     '/infrastructure-reports3013', '/aspirational-reports-4001', 
                     '/aspirational-reports-4002', '/aspirational-reports-4003', 
                     '/aspirational-reports-4004', '/school-reports-1006',
                    '/student-reports-4000', '/student-reports-4002', '/student-reports-4004','/student-reports-4007', '/student-reports-4006', '/student-reports-4008', '/student-reports-4009','/Enrollment-reports-4014',
                  '/student-reports-4010', '/student-reports-4011', '/student-reports-4032'];

// export const nationalWiseName = "All India/National";
export const nationalWiseName = "All India/National";
export const stateWiseName = "State Wise";
export const districtWiseName = "District Wise"
export const blockWiseName = "Block Wise"
export const district = "District";
export const block = "Block"
export const nWiseregionType = 10;
export const nWiseregionCode = "99"
export const selectedDYear = "2023-24"
export const selectedDYear2007 = "2023-24"
export const allSWiseregionType = 21
export const allSWiseregionCode = "11"
export const specificSWiseregionType = 11;
export const allDWiseregionType = 22;
export const specificDWiseregionType = 12;
export const allBWiseregionType = 23;
export const specificBWiseregionType = 13


export const modifiedFilterObjForReset = {
  regionCode: 99,
  regionType: 21,
  dType: 21, //21statewise //10 for all india
  dCode: 99, // 11statewise //99 for all india
  yearId: 10,
  valueType: 2,
};


export const modifiedFilterObjResetDashboard = {
  categoryCode: 0,
  dashboardRegionCode: "09",
  dashboardRegionType: 10,
  locationCode: 0,
  managementCode: 0,
  regionCode: 99,
  regionType: 21,
  dType: 10, //21statewise //10 for all india
  dCode: 99, // 11statewise //99 for all india
  schoolTypeCode: 0,
  yearId: 10,
  valueType: 2,
};


export const initialFilterSchoolData = {
    yearId: 10,
    regionType: 10,  //21statewise //10 for all india 
    regionCode: 99, // 11statewise //99 for all india
    dType: 10,  //21statewise //10 for all india 
    dCode: 99, // 11statewise //99 for all india
    categoryCode: 0,
    managementCode: 0,
    locationCode: 0,
    schoolTypeCode:0,
    dashboardRegionType:10,
    dashboardRegionCode:"09"
  }

  export const initialFilterSchoolProfileData = {
    yearId: 10,
    regionType: 10,  //21statewise //10 for all india 
    regionCode: 99, // 11statewise //99 for all india
    dType: 10,  //21statewise //10 for all india 
    dCode: 99, // 11statewise //99 for all india
    categoryCode: 0,
    managementCode: 0,
    locationCode: 0,
    schoolTypeCode:0,
    dashboardRegionType:10,
    dashboardRegionCode:"09"
  }


  export const initialFilterEnrolmentData = {
    "yearId":10,
    "regionType":10,
    "regionCode":11,
    "categoryCode":0,
    "managementCode":0,
    "locationCode": 0,
}

export const initialFilterEnrolmentSummarisedData = {
  "yearId":10,
    "regionType":10,
    "regionCode":11,
    "categoryCode":0,
    "managementCode":0,
    "locationCode": 0,
  "valueType": 1
}

export const initialFilterEnrolment4010 = {
  yearId: 10,
  regionType: 10,
  regionCode: 11,
};

export const initialFilterEnrolmentData4008 = {
  "yearId":10,
  "regionType":10,
  "regionCode":11,
  "categoryCode":0,
  "managementCode":0,
  "locationCode": 0,
  "itemGroup":2
}

export const initialFilterEnrolment = {
  "yearId":10,
  "regionType":10,
  "regionCode":99,
  "itemGroupId":"2",
  "itemId":"0"
}

  export const initialFilterMapData = {
    yearId: 10,
    regionType: 10,  //21statewise //10 for all india 
    regionCode: 99, // 11statewise //99 for all india
    dType: 21,  //21statewise //10 for all india 
    dCode: 99, // 11statewise //99 for all india
    categoryCode: 0,
    managementCode: 0,
    locationCode: 0,
    schoolTypeCode:0,
    dashboardRegionType:10,
    dashboardRegionCode:"09"
  }
  export const initialFilterPieGraphSchoolData={
    yearId: 10,
    regionType: 10,  //21statewise //10 for all india 
    regionCode: 99, // 11statewise //99 for all india
    dType: 10,  //21statewise //10 for all india 
    dCode: 99, // 11statewise //99 for all india
    categoryCode: 0,
    managementCode: 0,
    locationCode: 0,
    schoolTypeCode:0,
    dashboardRegionType:10,
    dashboardRegionCode:"09"


  }

  export const initialFilterPtRData = {
    yearId: 10,
    regionType: 10,  //21statewise //10 for all india 
    regionCode: 99, // 11statewise //99 for all india
    dType: 10,  //21statewise //10 for all india 
    dCode: 99, // 11statewise //99 for all india
  }

  export const initialFilterPtrDataYearWise = {
    yearId: 10,
    regionType: 10,  //21statewise //10 for all india 
    regionCode: 99, // 11statewise //99 for all india
    dType: 10,  //21statewise //10 for all india 
    dCode: 99, // 11statewise //99 for all india
    categoryCode: 0,
    managementCode: 0,
  
  }


  export const initialFilterPtRDataStateWise = {
    yearId: 10,
    regionType: 21,  //21statewise //10 for all india 
    regionCode: "11", // 11statewise //99 for all india
    dType: 21,  //21statewise //10 for all india 
    dCode: "11", // 11statewise //99 for all india
  }
  export const intialIndiaWiseFilterSchData={
    
      yearId: 10,
      regionType: 10,
      regionCode: "99",
      dType: 10,
      dCode: 99,
      categoryCode: 0,
      managementCode: 0,
      locationCode: 0,
      schoolTypeCode: 0,
      dashboardRegionType: 10,
      dashboardRegionCode: "09",
    
 
  }

  export const initialFilterEnrolmet4014Data = {
    yearId: 10,
    regionType: 10,  //21statewise //10 for all india 
    regionCode: 99, // 11statewise //99 for all india
    dType: 10,  //21statewise //10 for all india 
    dCode: 99, // 11statewise //99 for all india
    itemGroupId :0,
    itemId:0,
    dashboardRegionType:10,
    dashboardRegionCode:"09",
  }

  export const intialStateWiseFilterSchData = {
    yearId: 10,
    regionType: 21,
    regionCode: 11,
    dType: 21,
    dCode: 11,
    categoryCode: 0,
    managementCode: 0,
    locationCode: 0,
    schoolTypeCode: 0,
    dashboardRegionType: 11,
    dashboardRegionCode: 21,
    valueType: 1
  }
 export const categoryMappings = {
    "Primary": "Primary (I-V)",
    "Primary with Upper Primary": "Primary with Upper Primary (I-VIII)",
    "Pr. with Up.Pr. Sec. and H.Sec.": "Pr. with Up.Pr. Sec. and H.Sec. (I-XII)",
    "Upper Primary only": "Upper Primary only(VI-VIII)",
    "Secondary Only": "Secondary Only(IX-X)",
    "Upper Pr. and Secondary": "Upper Pr. and Secondary(VI-X)",
    "Secondary with Higher Secondary": "Secondary with Higher Secondary(IX-XII)",
    "Higher Secondary only/Jr. College": "Higher Secondary only/Jr. College(XI-XII)",
    "Up. Pr. Secondary and Higher": "Up. Pr. Secondary and Higher(VI-XII)",
    "Pr. Up Pr. and Secondary Only": "Pr. Up Pr. and Secondary Only(I-X)",
    "Up. Pr. Secondary and Higher Sec":"Up. Pr. Secondary and Higher Sec(VI-XII)"
  };

// managmnet  and category code for reports
  export const state_gov_mgt_code = ["1", "2", "3", "6", "89", "90", "91"];
  export const gov_aided_mgt_code = ["4", "7"];
  export const pvt_uaided_mgt_code = ["5"];
  export const ctrl_gov_mgt_code = ["92", "93", "94", "95", "96", "101"];
  export const other_mgt_code = ["8", "97", "99", "98", "102"];
  export const pr_sch_code = ["1"];
  export const upr_pr_code = ["2", "4"];
  export const hr_sec_code = ["3", "5", "10", "11"];
  export const sec_sch_code = ["6", "7", "8"];
  export const pre_pr_sch_code = ["12"];
  export const location_code_all = ["0"];
  export const location_code_rural = ["1"];
  export const location_code_urban = ["2"];
  export const boys_coed_toilet =["1","3"];
  export const girls_coed_toilet =["2","3"];
  export const foundational_preparatory = ["1", "12"]
  export const middle = ["2", "4"]
  export const secondary = ["3", "5", "6", "7", "8", "10", "11"]

    export const columnsConfig = [
      {
        headerNameKey: "Serial Number",
        field: "Serial Number",
        hide: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
      },
      {
        headerNameKey: "",
        children: [
          {
            headerNameKey: "",
            children: [
              {
                headerNameKey: "Location",
                field: "regionName",
               
              },
              {
                headerNameKey: "School Management(Broad)",
                field: "schManagementBroad",
              },
              {
                headerNameKey: "School Management(Detailed)",
                field: "schManagementDesc",
               
              },
              {
                headerNameKey: "School Category(Broad)",
                field: "schCategoryBroad",
              
              },
              {
                headerNameKey: "School Category(Detailed)",
                field: "schCategoryDesc",
                
              },
              {
                headerNameKey: "Urban/Rural",
                field: "schLocationDesc",
                
              },
            ],
          },
        ],
      },
      {
        headerNameKey: "Social Category",
        children: [
          {
            headerNameKey: "General",
            children: [
              { headerNameKey: "Female", field: "totTchFSocCatCd1", hide: false },
              { headerNameKey: "Male", field: "totTchMSocCatCd1", hide: false },
            ],
          },
          {
            headerNameKey: "OBC",
            children: [
              { headerNameKey: "Female", field: "totTchFSocCatCd4" },
              { headerNameKey: "Male", field: "totTchMSocCatCd4" },
            ],
          },
          {
            headerNameKey: "SC",
            children: [
              { headerNameKey: "Female", field: "totTchFSocCatCd2", hide: false },
              { headerNameKey: "Male", field: "totTchMSocCatCd2", hide: false },
            ],
          },
          {
            headerNameKey: "ST",
            children: [
              { headerNameKey: "Female", field: "totTchFSocCatCd3" },
              { headerNameKey: "Male", field: "totTchMSocCatCd3" },
            ],
          },
          {
            headerNameKey: "",
            hide: false,
            children: [
              {
                headerNameKey: "Overall",
                field: "total",
                valueGetter: (params) => params.data ? params.data.total : null,
                aggFunc: 'sum', 
              },
            ],
          },
        ],
      },
    ];

    export const columnsConfigFor2001 = [
       {
          headerName: "Serial Number",
          field: "Serial Number",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressFiltersToolPanel: true,
        },
        {
          headerName: "Location",
          field: "regionName",
          hide: true,
        },
        {
          headerName: "School Management(Broad)",
          field: "schManagementBroad",
          suppressColumnsToolPanel: true,
          hide: false,
        },
        {
          headerName: "School Management(Detailed)",
          field: "schManagementDesc",
          suppressColumnsToolPanel: true,
          hide: false,
        },
        {
          headerName: "School Category(Broad)",
          field: "schCategoryBroad",
          suppressColumnsToolPanel: true,
          hide: false,
        },
        {
          headerName: "School Category(Details)",
          field: "schCategoryDesc",
          suppressColumnsToolPanel: true,
          hide: false,
        },
        {
          headerName: "Total No. of Schools",
          field: "totSch",
          cellClass: 'ag-right-aligned-cell'
        },
    ];

    export const columnsConfigFor2002 = [
      {
        headerNameKey: "Serial Number",
        field: "Serial Number",
        hide: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
      },
      {
        headerNameKey: "",
        children: [
          {
            headerNameKey: "",
            children: [
              {
                headerNameKey: "Location",
                field: "regionName",
               
              },
              {
                headerNameKey: "Management Name(Broad)",
                field: "schManagementBroad",
              },
              {
                headerNameKey: "Management Name(Detailed)",
                field: "schManagementDesc",
               
              },
              {
                headerNameKey: "Urban/Rural",
                field: "schLocURDesc",
                
              },
            ],
          },
        ],
      },
      {
        headerNameKey: "",
        children: [
          {
            headerNameKey: "Pre-Primary Only",
            children: [
              { headerNameKey: "Female", field: "totTchFClsTaughtCd10", hide: false },
              { headerNameKey: "Male", field: "totTchMClsTaughtCd10", hide: false },
              { headerNameKey: "Total", field: "totTchClsTaughtCd10" },

            ],
          },
          {
            headerNameKey: "Pre-Primary & Primary(1-5)",
            children: [
              { headerNameKey: "Female", field: "totTchFClsTaughtCd11" },
              { headerNameKey: "Male", field: "totTchMClsTaughtCd11" },
              { headerNameKey: "Total", field: "totTchClsTaughtCd11" },

            ],
          },
          {
            headerNameKey: "Pre-Primary Total(A+B)",
            children: [
              { headerNameKey: "Female", field: "totFPrePriToughtCd", hide: false },
              { headerNameKey: "Male", field: "totMPrePriToughtCd", hide: false },
              { headerNameKey: "Total", field: "totPrePriToughtCd" },

            ],
          },
          {
            headerNameKey: "Primary Only(1-5)",
            children: [
              { headerNameKey: "Female", field: "totTchFClsTaughtCd1" },
              { headerNameKey: "Male", field: "totTchMClsTaughtCd1" },
              { headerNameKey: "Total", field: "totTchClsTaughtCd1" },
            ],
          },
          {
            headerNameKey: "Primary Total(1-5)",
            children: [
              { headerNameKey: "Female", field: "totFPriToughtCd" },
              { headerNameKey: "Male", field: "totMPriToughtCd" },
              { headerNameKey: "Total", field: "totPriToughtCd" },

            ],
          },
          {
            headerNameKey: "Primary(1-5) & Upper Primary(6-8)",
            children: [
              { headerNameKey: "Female", field: "totTchFClsTaughtCd3" },
              { headerNameKey: "Male", field: "totTchMClsTaughtCd3" },
              { headerNameKey: "Total", field: "totTchClsTaughtCd3" },

            ],
          },
          {
            headerNameKey: "Upper Primary Only(6-8)",
            children: [
              { headerNameKey: "Female", field: "totTchFClsTaughtCd2" },
              { headerNameKey: "Male", field: "totTchMClsTaughtCd2" },
              { headerNameKey: "Total", field: "totTchClsTaughtCd2" },

            ],
          },
          {
            headerNameKey: "Upper Primary(6-8) & Secondary (9-10)",
            children: [
              { headerNameKey: "Female", field: "totTchFClsTaughtCd7" },
              { headerNameKey: "Male", field: "totTchMClsTaughtCd7" },
              { headerNameKey: "Total", field: "totTchClsTaughtCd7" },

            ],
          },
          {
            headerNameKey: "Upper Primary Total(6-8)",
            children: [
              { headerNameKey: "Female", field: "totFUPriToughtCd" },
              { headerNameKey: "Male", field: "totMUPriToughtCd" },
              { headerNameKey: "Total", field: "totUPriToughtCd" },

            ],
          },
          {
            headerNameKey: "Secondary Only(9-10)",
            children: [
              { headerNameKey: "Female", field: "totTchFClsTaughtCd5" },
              { headerNameKey: "Male", field: "totTchMClsTaughtCd5" },
              { headerNameKey: "Total", field: "totTchClsTaughtCd5" },

            ],
          },
          {
            headerNameKey: "Secondary Only(9-10) & Higher Secondary (11-12)",
            children: [
              { headerNameKey: "Female", field: "totTchFClsTaughtCd8" },
              { headerNameKey: "Male", field: "totTchMClsTaughtCd8" },
              { headerNameKey: "Total", field: "totTchClsTaughtCd8" },

            ],
          },
          {
            headerNameKey: "Secondary Total",
            children: [
              { headerNameKey: "Female", field: "totFSecToughtCd" },
              { headerNameKey: "Male", field: "totMSecToughtCd" },
              { headerNameKey: "Total", field: "totSecToughtCd" },

            ],
          },
          {
            headerNameKey: "Higher Secondary Only(11-12)",
            children: [
              { headerNameKey: "Female", field: "totTchFClsTaughtCd6" },
              { headerNameKey: "Male", field: "totTchMClsTaughtCd6" },
              { headerNameKey: "Total", field: "totTchClsTaughtCd6" },

            ],
          },
          {
            headerNameKey: "Higher Secondary Total(11-12)",
            children: [
              { headerNameKey: "Female", field: "totFHSecToughtCd" },
              { headerNameKey: "Male", field: "totMHSecToughtCd" },
              { headerNameKey: "Total", field: "totHSecToughtCd" },

            ],
          },
         
          // {
          //   headerNameKey: "",
          //   hide: false,
          //   children: [
          //     {
          //       headerNameKey: "Overall",
          //       field: "total",
          //       valueGetter: (params) => params.data ? params.data.total : null,
          //       aggFunc: 'sum', 
          //     },
          //   ],
          // },
        ],
      },
    ];

    export const columnsConfigFor2009 = [
      {
        headerNameKey: "Serial Number",
        field: "Serial Number",
        hide: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
      },
      {
        headerNameKey: "",
        children: [
          {
            headerNameKey: "",
            children: [
              {
                headerNameKey: "Location",
                field: "regionName",
               
              },
              {
                headerNameKey: "School Management(Broad)",
                field: "schManagementBroad",
              },
              {
                headerNameKey: "School Management(Detailed)",
                field: "schManagementDesc",
              },
              {
                headerNameKey: "School Category(Broad)",
                field: "schCategoryBroad",
            },
  
              {
                  headerNameKey: "School Category(Detailed)",
                  field: "schCategoryDesc"
              },
              {
                headerNameKey: "Urban/Rural",
                field: "schLocURDesc",
                
              },
            ],
          },
        ],
      },
      {
        headerNameKey: "Disability Type",
        children: [
          {
            headerNameKey: "Locomotor",
            children: [
              { headerNameKey: "Male", field: "maleTeachersDisability2", hide: false },
              { headerNameKey: "Female", field: "femaleTeachersDisability2", hide: false },
              { headerNameKey: "Total", field: "teachersDisability2" },

            ],
          },
          {
            headerNameKey: "Visual",
            children: [
              { headerNameKey: "Male", field: "maleTeachersDisability3" },
              { headerNameKey: "Female", field: "femaleTeachersDisability3" },
              { headerNameKey: "Total", field: "teachersDisability3" },

            ],
          },
          {
            headerNameKey: "Hearing Impaired",
            children: [
              { headerNameKey: "Male", field: "maleTeachersDisability5" },
              { headerNameKey: "Female", field: "femaleTeachersDisability5" },
              { headerNameKey: "Total", field: "teachersDisability5" },

            ],
          },
          {
            headerNameKey: "Others",
            children: [
              { headerNameKey: "Male", field: "maleTeachersDisability4" },
              { headerNameKey: "Female", field: "femaleTeachersDisability4" },
              { headerNameKey: "Total", field: "teachersDisability4" },

            ],
          },
         
        //   {
        //     headerNameKey: "",
        //     hide: false,
        //     children: [
        //       {
        //         headerNameKey: "Overall",
        //         field: "total",
        //         valueGetter: (params) => params.data ? params.data.total : null,
        //         aggFunc: 'sum', 
        //       },
        //     ],
        //   },
        ],
      },
    ];

    export const columnsConfigFor2010 = [
      {
        headerNameKey: "Serial Number",
        field: "Serial Number",
        hide: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
      },
      {
        headerNameKey: "",
        children: [
          {
            headerNameKey: "",
            children: [
              {
                headerNameKey: "Location",
                field: "regionName",
               
              },
              {
                headerNameKey: "School Management(Broad)",
                field: "schManagementBroad",
              },
              {
                headerNameKey: "School Management(Detailed)",
                field: "schManagementDesc",
              },
              {
                headerNameKey: "School Category(Detailed)",
                field: "schCategoryDesc",
              },
              {
                headerNameKey: "Urban/Rural",
                field: "schLocURDesc",
                
              },
            ],
          },
        ],
      },
      {
        headerNameKey: "Nature Of Appointment",
        children: [
          {
            headerNameKey: "Regular",
            children: [
              { headerNameKey: "Male", field: "totTchRegM", hide: false },
              { headerNameKey: "Female", field: "totTchRegF", hide: false },
              { headerNameKey: "Total", field: "totTchReg" },

            ],
          },
          {
            headerNameKey: "Non-Regular",
            children: [
              { headerNameKey: "Male", field: "totTchNonRegM" },
              { headerNameKey: "Female", field: "totTchNonRegF" },
              { headerNameKey: "Total", field: "totTchNonReg" },

            ],
          },
         
        //   {
        //     headerNameKey: "",
        //     hide: false,
        //     children: [
        //       {
        //         headerNameKey: "Overall",
        //         field: "total",
        //         valueGetter: (params) => params.data ? params.data.total : null,
        //         aggFunc: 'sum', 
        //       },
        //     ],
        //   },
        ],
      },
    ];

    export const columnsConfigFor2011 = [
      {
        headerNameKey: "Serial Number",
        field: "Serial Number",
        hide: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
      },
      {
        headerNameKey: "",
        children: [
          {
            headerNameKey: "",
            children: [
              {
                headerNameKey: "Location",
                field: "regionName",
               
              },
              {
                headerNameKey: "School Management(Broad)",
                field: "schManagementBroad",
              },
              {
                headerNameKey: "School Management(Detailed)",
                field: "schManagementDesc",
              },
              {
                headerName: "School Category(Detailed)",
                field: "schCatDesc",
                suppressColumnsToolPanel: true,
                hide: true,
              },
              {
                headerNameKey: "Urban/Rural",
                field: "schLocURDesc",
                
              },
            ],
          },
        ],
      },
      {
        headerNameKey: "",
        children: [
          {
            headerNameKey: "Teacher Trained for CWSN",
            children: [
              { headerNameKey: "Male", field: "totTchCWSNTrainedM", hide: false },
              { headerNameKey: "Female", field: "totTchCWSNTrainedF", hide: false },
              { headerNameKey: "Total", field: "totTchCWSNTrained" },

            ],
          }
         
        //   {
        //     headerNameKey: "",
        //     hide: false,
        //     children: [
        //       {
        //         headerNameKey: "Overall",
        //         field: "total",
        //         valueGetter: (params) => params.data ? params.data.total : null,
        //         aggFunc: 'sum', 
        //       },
        //     ],
        //   },
        ],
      },
    ];

    export const columnsConfigFor4002 = [
      {
        headerNameKey: "Serial Number",
        field: "Serial Number",
        hide: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
      },
      {
        headerNameKey: "",
        children: [
          {
            headerNameKey: "",
            children: [
              {
                headerNameKey: "Location",
                field: "regionName",
               
              },
              {
                headerNameKey: "School Management(Broad)",
                field: "schManagementBroad",
              },
              {
                headerNameKey: "School Management(Detailed)",
                field: "schMgmtCenterDesc",
               
              },
              {
                headerNameKey: "School Category(Broad)",
                field: "schCategoryBroad",
              
              },
              {
                headerNameKey: "School Category(Detailed)",
                field: "schCategoryIdDesc",
                
              },
              {
                headerNameKey: "Urban/Rural",
                field: "schLocURDesc",
                
              },
            ],
          },
        ],
      },
      {
        headerNameKey: "",
        children: [
          {
            headerNameKey: "Balvatika-1",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "prePry3G", hide: false },
              { headerNameKey: "Boys", field: "prePry3B", hide: false },
            ],
          },
          {
            headerNameKey: "Balvatika-2",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "prePry2G", hide: false },
              { headerNameKey: "Boys", field: "prePry2B", hide: false },
            ],
          },
          {
            headerNameKey: "Balvatika-3",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "prePry1G", hide: false },
              { headerNameKey: "Boys", field: "prePry1B", hide: false },
            ],
          },
          {
            headerNameKey: "Class-1",
            children: [
              { headerNameKey: "Girls", field: "class1G" },
              { headerNameKey: "Boys", field: "class1B" },
            ],
          },
          {
            headerNameKey: "Class-2",
            children: [
              { headerNameKey: "Girls", field: "class2G", hide: false },
              { headerNameKey: "Boys", field: "class2B", hide: false },
            ],
          },

          {
            headerNameKey: "Class-3",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "class3G" },
              { headerNameKey: "Boys", field: "class3B" },
            ],
          },

          {
            headerNameKey: "Class-4",
            children: [
              { headerNameKey: "Girls", field: "class4G" },
              { headerNameKey: "Boys", field: "class4B" },
            ],
          },
          {
            headerNameKey: "Class-5",
            children: [
              { headerNameKey: "Girls", field: "class5G" },
              { headerNameKey: "Boys", field: "class5B" },
            ],
          },
          {
            headerNameKey: "Class-6",
            children: [
              { headerNameKey: "Girls", field: "class6G" },
              { headerNameKey: "Boys", field: "class6B" },
            ],
          },
          {
            headerNameKey: "Class-7",
            children: [
              { headerNameKey: "Girls", field: "class7G" },
              { headerNameKey: "Boys", field: "class7B" },
            ],
          },
          {
            headerNameKey: "Class-8",
            children: [
              { headerNameKey: "Girls", field: "class8G" },
              { headerNameKey: "Boys", field: "class8B" },
            ],
          },
          {
            headerNameKey: "Class-9",
            children: [
              { headerNameKey: "Girls", field: "class9G" },
              { headerNameKey: "Boys", field: "class9B" },
            ],
          },
          {
            headerNameKey: "Class-10",
            children: [
              { headerNameKey: "Girls", field: "class10G" },
              { headerNameKey: "Boys", field: "class10B" },
            ],
          },
          {
            headerNameKey: "Class-11",
            children: [
              { headerNameKey: "Girls", field: "class11G" },
              { headerNameKey: "Boys", field: "class11B" },
            ],
          },
          {
            headerNameKey: "Class-12",
            children: [
              { headerNameKey: "Girls", field: "class12G" },
              { headerNameKey: "Boys", field: "class12B" },
            ],
          },
          // {
          //   headerNameKey: "Primary (1-5)",
          //   children: [
          //     { headerNameKey: "Girls", field: "totEnrPryG" },
          //     { headerNameKey: "Boys", field: "totEnrPryB" },
          //   ],
          // },
          // {
          //   headerNameKey: "Upper Primary (6-8)",
          //   children: [
          //     { headerNameKey: "Girls", field: "totEnrUPryG" },
          //     { headerNameKey: "Boys", field: "totEnrUPryB" },
          //   ],
          // },
          // {
          //   headerNameKey: "Secondary (9-10)",
          //   children: [
          //     { headerNameKey: "Girls", field: "totEnrSecG" },
          //     { headerNameKey: "Boys", field: "totEnrSecB" },
          //   ],
          // },
          // {
          //   headerNameKey: "Higher Secondary (11-12)",
          //   children: [
          //     { headerNameKey: "Girls", field: "totEnrHSecG" },
          //     { headerNameKey: "Boys", field: "totEnrHSecB" },
          //   ],
          // },
          // {
          //   headerNameKey: "Total without Pre-Primary",
          //   children: [
          //     { headerNameKey: "Girls", field: "withoutPPrytotEnrG" },
          //     { headerNameKey: "Boys", field: "withoutPPrytotEnrB" },
          //   ],
          // },
          // {
          //   headerNameKey: "Total with Pre-Primary",
          //   children: [
          //     { headerNameKey: "Girls", field: "totEnrG" },
          //     { headerNameKey: "Boys", field: "totEnrB" },
          //   ],
          // },
          {
            headerNameKey: "",
            hide: false,
            children: [
              {
                headerNameKey: "Overall",
                field: "total",
                valueGetter: (params) => params.data ? params.data.total : null,
                aggFunc: 'sum', 
              },
            ],
          },
        ],
      },
    ];

    export const columnsConfigFor4000 = [
      {
        headerNameKey: "Serial Number",
        field: "Serial Number",
        hide: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
      },
      {
        headerNameKey: "",
        children: [
          {
            headerNameKey: "",
            children: [
              {
                headerNameKey: "Location",
                field: "regionName",
               
              },
              {
                headerNameKey: "School Management(Broad)",
                field: "schManagementBroad",
              },
              {
                headerNameKey: "School Management(Detailed)",
                field: "schMgmtCenterIdDesc",
               
              },
              {
                headerNameKey: "School Category(Broad)",
                field: "schCategoryBroad",
              
              },
              {
                headerNameKey: "School Category(Detailed)",
                field: "schCategoryIdDesc",
                
              },
              {
                headerNameKey: "Urban/Rural",
                field: "schLocURDesc",
                
              },
            ],
          },
        ],
      },
      {
        headerNameKey: "",
        children: [
          {
            headerNameKey: "Foundational",
            children: [
              { headerNameKey: "Girls", field: "totEnrPrePryG", hide: false },
              { headerNameKey: "Boys", field: "totEnrPrePryB", hide: false },
            ],
          },
        
          {
            headerNameKey: "Preparatory",
            children: [
              { headerNameKey: "Girls", field: "totEnrPryG" },
              { headerNameKey: "Boys", field: "totEnrPryB" },
            ],
          },
          {
            headerNameKey: "Middle",
            children: [
              { headerNameKey: "Girls", field: "totEnrUPryG" },
              { headerNameKey: "Boys", field: "totEnrUPryB" },
            ],
          },
          {
            headerNameKey: "Secondary",
            children: [
              { headerNameKey: "Girls", field: "totEnrSecG" },
              { headerNameKey: "Boys", field: "totEnrSecB" },
            ],
          },
        
          {
            headerNameKey: "",
            hide: false,
            children: [
              {
                headerNameKey: "Overall",
                field: "total",
                valueGetter: (params) => params.data ? params.data.total : null,
                aggFunc: 'sum', 
              },
            ],
          },
        ],
      },
    ];
    export const columnsConfigFor4004 = [
      {
        headerNameKey: "Serial Number",
        field: "Serial Number",
        hide: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
      },
      {
        headerNameKey: "",
        children: [
          {
            headerNameKey: "",
            children: [
              {
                headerNameKey: "Location",
                field: "regionName",
               
              },
              {
                headerNameKey: "School Management(Broad)",
                field: "schManagementBroad",
              },
              {
                headerNameKey: "School Management(Detailed)",
                field: "schMgmtCenterIdDesc",
               
              },
              {
                headerNameKey: "School Category(Broad)",
                field: "schCategoryBroad",
              
              },
              {
                headerNameKey: "School Category(Detailed)",
                field: "schCategoryIdDesc",
                
              },
              {
                headerNameKey: "Urban/Rural",
                field: "schLocURDesc",
                
              },
              {
                headerNameKey: "Social Category",
                field: "category",
              },
            ],
          },
        ],
      },
      {
        headerNameKey: "",
        children: [
          {
            headerNameKey: "Balvatika-1",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "prePry3G", hide: false },
              { headerNameKey: "Boys", field: "prePry3B", hide: false },
            ],
          },
          {
            headerNameKey: "Balvatika-2",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "prePry2G", hide: false },
              { headerNameKey: "Boys", field: "prePry2B", hide: false },
            ],
          },
          {
            headerNameKey: "Balvatika-3",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "prePry1G", hide: false },
              { headerNameKey: "Boys", field: "prePry1B", hide: false },
            ],
          },
          {
            headerNameKey: "Class-1",
            children: [
              { headerNameKey: "Girls", field: "class1G" },
              { headerNameKey: "Boys", field: "class1B" },
            ],
          },
          {
            headerNameKey: "Class-2",
            children: [
              { headerNameKey: "Girls", field: "class2G", hide: false },
              { headerNameKey: "Boys", field: "class2B", hide: false },
            ],
          },
          {
            headerNameKey: "Class-3",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "class3G" },
              { headerNameKey: "Boys", field: "class3B" },
            ],
          },
          {
            headerNameKey: "Class-4",
            children: [
              { headerNameKey: "Girls", field: "class4G" },
              { headerNameKey: "Boys", field: "class4B" },
            ],
          },
          {
            headerNameKey: "Class-5",
            children: [
              { headerNameKey: "Girls", field: "class5G" },
              { headerNameKey: "Boys", field: "class5B" },
            ],
          },
          {
            headerNameKey: "Class-6",
            children: [
              { headerNameKey: "Girls", field: "class6G" },
              { headerNameKey: "Boys", field: "class6B" },
            ],
          },
          {
            headerNameKey: "Class-7",
            children: [
              { headerNameKey: "Girls", field: "class7G" },
              { headerNameKey: "Boys", field: "class7B" },
            ],
          },
          {
            headerNameKey: "Class-8",
            children: [
              { headerNameKey: "Girls", field: "class8G" },
              { headerNameKey: "Boys", field: "class8B" },
            ],
          },
          {
            headerNameKey: "Class-9",
            children: [
              { headerNameKey: "Girls", field: "class9G" },
              { headerNameKey: "Boys", field: "class9B" },
            ],
          },
          {
            headerNameKey: "Class-10",
            children: [
              { headerNameKey: "Girls", field: "class10G" },
              { headerNameKey: "Boys", field: "class10B" },
            ],
          },
          {
            headerNameKey: "Class-11",
            children: [
              { headerNameKey: "Girls", field: "class11G" },
              { headerNameKey: "Boys", field: "class11B" },
            ],
          },
          {
            headerNameKey: "Class-12",
            children: [
              { headerNameKey: "Girls", field: "class12G" },
              { headerNameKey: "Boys", field: "class12B" },
            ],
          },
         
          {
            headerNameKey: "",
            hide: false,
            children: [
              {
                headerNameKey: "Overall",
                field: "total",
                valueGetter: (params) => params.data ? params.data.total : null,
                aggFunc: 'sum', 
              },
            ],
          },
        ],
      },
    ];

    export const columnsConfigFor4007 = [
      {
        headerNameKey: "Serial Number",
        field: "Serial Number",
        hide: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
      },
      {
        headerNameKey: "",
        children: [
          {
            headerNameKey: "",
            children: [
              {
                headerNameKey: "Location",
                field: "regionName",
               
              },
              {
                headerNameKey: "School Management(Broad)",
                field: "schManagementBroad",
              },
              {
                headerNameKey: "School Management(Detailed)",
                field: "schMgmtCenterDesc",
               
              },
              {
                headerNameKey: "School Category(Broad)",
                field: "schCategoryBroad",
              
              },
              {
                headerNameKey: "School Category(Detailed)",
                field: "schCategoryIdDesc",
                
              },
              {
                headerNameKey: "Urban/Rural",
                field: "schLocURDesc",
                
              },
              {
                headerNameKey: "Category",
                field: "category",
              },
            ],
          },
        ],
      },
      {
        headerNameKey: "",
        children: [
          {
            headerNameKey: "Balvatika-1",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "pp3G", hide: false },
              { headerNameKey: "Boys", field: "pp3B", hide: false },
            ],
          },
          {
            headerNameKey: "Balvatika-2",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "pp2G", hide: false },
              { headerNameKey: "Boys", field: "pp2B", hide: false },
            ],
          },
          {
            headerNameKey: "Balvatika-3",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "pp1G", hide: false },
              { headerNameKey: "Boys", field: "pp1B", hide: false },
            ],
          },
          {
            headerNameKey: "Class-1",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "c1G" },
              { headerNameKey: "Boys", field: "c1B" },
            ],
          },
          {
            headerNameKey: "Class-2",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "c2G", hide: false },
              { headerNameKey: "Boys", field: "c2B", hide: false },
            ],
          },

          {
            headerNameKey: "Class-3",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "c3G" },
              { headerNameKey: "Boys", field: "c3B" },
            ],
          },
          {
            headerNameKey: "Class-4",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "c4G" },
              { headerNameKey: "Boys", field: "c4B" },
            ],
          },
          {
            headerNameKey: "Class-5",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "c5G" },
              { headerNameKey: "Boys", field: "c5B" },
            ],
          },
          {
            headerNameKey: "Class-6",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "c6G" },
              { headerNameKey: "Boys", field: "c6B" },
            ],
          },
          {
            headerNameKey: "Class-7",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "c7G" },
              { headerNameKey: "Boys", field: "c7B" },
            ],
          },
          {
            headerNameKey: "Class-8",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "c8G" },
              { headerNameKey: "Boys", field: "c8B" },
            ],
          },
          {
            headerNameKey: "Class-9",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "c9G" },
              { headerNameKey: "Boys", field: "c9B" },
            ],
          },
          {
            headerNameKey: "Class-10",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "c10G" },
              { headerNameKey: "Boys", field: "c10B" },
            ],
          },
          {
            headerNameKey: "Class-11",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "c11G" },
              { headerNameKey: "Boys", field: "c11B" },
            ],
          },
          {
            headerNameKey: "Class-12",
            hide: false,
            children: [
              { headerNameKey: "Girls", field: "c12G" },
              { headerNameKey: "Boys", field: "c12B" },
            ],
          },
         
          {
            headerNameKey: "",
            hide: false,
            children: [
              {
                headerNameKey: "Overall",
                field: "total",
                valueGetter: (params) => params.data ? params.data.total : null,
                aggFunc: 'sum', 
              },
            ],
          },
        ],
      },
    ];

  

    export const columnsConfigFor4010 = [
      {
        headerNameKey: "Serial Number",
        field: "Serial Number",
        hide: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
      },
      {
        headerNameKey: "",
        children: [
          {
            headerNameKey: "",
            children: [
              {
                headerNameKey: "Location",
                field: "regionName",
               
              },
            ],
          },
        ],
      },
      {
        headerName: "Social Category",
        children: [
          {
            headerNameKey: "Foundational",
            children: [
              { headerNameKey: "Boys", field: "priB" },
              { headerNameKey: "Girls", field: "priG" },
              { headerNameKey: "Overall", field: "priT" },
            ],
          },
          {
            headerNameKey: "Preparatory",
            children: [
              { headerNameKey: "Boys", field: "upriB" },
              { headerNameKey: "Girls", field: "upriG" },
              { headerNameKey: "Overall", field: "upriT" },
            ],
          },
          // {
          //   headerNameKey: "Elementary(1-8)",
          //   children: [
          //     { headerNameKey: "Boys", field: "elemB" },
          //     { headerNameKey: "Girls", field: "elemG" },
          //     { headerNameKey: "Overall", field: "elemT" },
          //   ],
          // },
          {
            headerNameKey: "Middle",
            children: [
              { headerNameKey: "Boys", field: "secB" },
              { headerNameKey: "Girls", field: "secG" },
              { headerNameKey: "Overall", field: "secT" },
            ],
          },
          {
            headerNameKey: "Secondary",
            children: [
              { headerNameKey: "Boys", field: "hsecB" },
              { headerNameKey: "Girls", field: "hsecG" },
              { headerNameKey: "Overall", field: "hsecT" },
            ],
          },
          // {
          //   headerName: "Overall",
          //   hide: false,
          //   children: [
          //     {
          //       headerName: "Overall",
          //       field: "total",
          //       valueGetter: (params) => (params.data ? params.data.total : null),
          //       aggFunc: "sum",
          //     },
          //   ],
          // },
        ],
      },
    ];

      export const columnsConfigFor4011 = [
      {
        headerNameKey: "Serial Number",
        field: "Serial Number",
        hide: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
      },
      {
        headerNameKey: "",
        children: [
          {
            headerNameKey: "",
            children: [
              {
                headerNameKey: "Location",
                field: "regionName",
               
              },
            ],
          },
        ],
      },
      {
        headerName: "Social Category",
        children: [
          {
            headerNameKey: "Foundational",
            children: [
              { headerNameKey: "Boys", field: "priB" },
              { headerNameKey: "Girls", field: "priG" },
              { headerNameKey: "Overall", field: "priT" },
            ],
          },
          {
            headerNameKey: "Preparatory",
            children: [
              { headerNameKey: "Boys", field: "upriB" },
              { headerNameKey: "Girls", field: "upriG" },
              { headerNameKey: "Overall", field: "upriT" },
            ],
          },
          // {
          //   headerNameKey: "Elementary(1-8)",
          //   children: [
          //     { headerNameKey: "Boys", field: "elemB" },
          //     { headerNameKey: "Girls", field: "elemG" },
          //     { headerNameKey: "Overall", field: "elemT" },
          //   ],
          // },
          {
            headerNameKey: "Middle",
            children: [
              { headerNameKey: "Boys", field: "secB" },
              { headerNameKey: "Girls", field: "secG" },
              { headerNameKey: "Overall", field: "secT" },
            ],
          },
          {
            headerNameKey: "Secondary",
            children: [
              { headerNameKey: "Boys", field: "hsecB" },
              { headerNameKey: "Girls", field: "hsecG" },
              { headerNameKey: "Overall", field: "hsecT" },
            ],
          },
          // {
          //   headerName: "Overall",
          //   hide: false,
          //   children: [
          //     {
          //       headerName: "Overall",
          //       field: "total",
          //       valueGetter: (params) => (params.data ? params.data.total : null),
          //       aggFunc: "sum",
          //     },
          //   ],
          // },
        ],
      },
    ];

    export const columnsConfigFor4032 = [
      {
        headerNameKey: "Serial Number",
        field: "Serial Number",
        hide: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
      },
    
      {
        headerNameKey: "Location",
        field: "regionName",
        hide: false,
      },
      {
        headerNameKey: "Foundational",
        field: "priT",
        hide: false,
      },
      {
        headerNameKey: "Preparatory",
        field: "upriT",
        hide: false,
      },
      {
        headerNameKey: "Middle",
        field : "secT",
        hide: false,
      },
      // {
      //   headerNameKey: "Elementry(1-8)",
      //   field: "elemT",
      //   hide: false,
      // },
      {
        headerNameKey: "Secondary",
        field: "hsecT",
        hide: false,
      },
     
    ];
    export const modifyobject = {
      categoryCode: 0,
      locationCode: 0,
      managementCode: 0,
      regionCode: 99,
      regionType: 10,
      dType: 10, //21statewise //10 for all india change 21 to 10
      dCode: 99, // 11statewise //99 for all india change 11 to 99
      schoolTypeCode: 0,
      yearId: 10,
    };
    //  This is for show Location in pdf file
    
    export const generateTextContent = (stateName, nationalWiseName, stateWiseName, local_district, district, districtWiseName, local_block, block,blockWiseName) => {
      let textContent = "";
      if (stateName === nationalWiseName) {
        textContent = `${nationalWiseName}`;
      } else if (stateName === stateWiseName) {
        textContent = `National(${stateWiseName})`;
      } else if (stateName !== nationalWiseName && stateName !== stateWiseName && local_district === district) {
        textContent = `State-${stateName}`;
      } else if (stateName !== nationalWiseName && stateName !== stateWiseName && local_district !== district && local_district !== districtWiseName && local_block !== blockWiseName && local_block !== block) {
        textContent = `Block -${local_block} (${local_district} (${stateName}))`;
      } else if (stateName !== nationalWiseName && stateName !== stateWiseName && local_district !== districtWiseName && local_district !== district && local_block === blockWiseName) {
        textContent = `${stateName} (${local_district} (${blockWiseName}))`;
      } else if (stateName !== nationalWiseName && stateName !== stateWiseName && local_district !== district && local_district !== districtWiseName) {
        textContent = `District - ${local_district} (${stateName})`;
      } else if (stateName !== nationalWiseName && stateName !== stateWiseName && local_district === districtWiseName) {
        textContent = `${stateName} (${districtWiseName})`;
      }
    
      return textContent;
    };
   export const rangeMapping = {
      gross_enrollment_ratio: ["<=50", "50.1-60.0", "60.1-70.0", "70"],
      dropout_rate: ["15+", "10.1-15.0", "5.1-10.0", "0-5.0"],
      // dropout_ratio: ["8+", "5.1-8.0", "3.1-5.0", "0-3"],
      dropout_ratio: ["0-3","3.1-5.0", "5.1-8.0", "8"],
      transition_rate: ["<=85", "85.1-90.0", "90.1-95.0", "95"],
      pupil_teacher_ratio: ["40+", "35-40", "31-35", "30 and Below"],
      schools_with_drinking_water: ["<=85", "85.01-90.00", "90.01-95.00", "95"],
      schools_with_electricity_connection: ["<=70", "70.01-80.00", "80.01-90.00", "90"],

      //
      toilet: ["<=85", "85.01-90.00", "90.01-95.00", "95"],
      libraries:  ["<=50", "51.01-70.00", "71.01-90.00", "90"],
      ramp:  ["<=50", "51.01-70.00", "71.01-90.00", "90"],
      nature_of_appointment:  ["<=30", "30.01-50.00", "50.01-80.00", "80"],
      trained_teacher_for_cwsn:  ["<=3", "3.01-5.00", "5.01-8.00", "8"],
      "teacher_trained_&_teaching_through_computer":  ["<=30", "30.01-50.00", "50.01-80.00", "80"],
      gender_parity_index:  ["Below 0.90", "0.90-0.95", "0.96-0.99", "1.00 onwards"],
     
      // dropout_ratio:  ["Below 3", "3-5", "5-8", "8"],
    };